import { useRef, useState } from "react";
import { UploadCloud } from "lucide-react";

export const Dropzone = ({ accept, onFiles, multiple = false, disabled, label, hint, cta, testId = "upload-dropzone" }) => {
  const input = useRef(null);
  const [over, setOver] = useState(false);
  const pick = (list) => {
    const files = Array.from(list || []);
    if (files.length && !disabled) onFiles(files);
  };
  return (
    <div
      data-testid={testId}
      onClick={() => !disabled && input.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setOver(true); }}
      onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); pick(e.dataTransfer.files); }}
      className={`group relative flex min-h-[320px] cursor-pointer flex-col items-center justify-center rounded-2xl border-2 border-dashed bg-white p-10 text-center transition-colors ${over ? "border-[#00A3E0] bg-sky-50/60" : "border-slate-300 hover:border-slate-900"} ${disabled ? "pointer-events-none opacity-60" : ""}`}
    >
      <div className="grid h-16 w-16 place-items-center rounded-2xl bg-slate-900 text-white transition-transform group-hover:-translate-y-1">
        <UploadCloud className="h-7 w-7" />
      </div>
      <p className="mt-6 font-display text-xl font-semibold text-slate-900">{label}</p>
      <p className="mt-2 text-sm text-slate-500">{hint}</p>
      <span className="mt-6 rounded-full border border-slate-200 px-4 py-1.5 font-mono text-xs uppercase tracking-wider text-slate-500">{cta}</span>
      <input
        ref={input}
        type="file"
        accept={accept}
        multiple={multiple}
        className="hidden"
        data-testid="upload-file-input"
        onChange={(e) => { pick(e.target.files); e.target.value = ""; }}
      />
    </div>
  );
};
